<template>
  <div class="settings">
    <div class="settings__content">
      <div class="profile-edit">
        <div class="profile-edit__container -password-">
          <div class="profile-edit__row">
            <div class="profile-edit__col">
              <div class="profile-edit__field">
                <UiInput
                  v-model.trim="user.currentPassword"
                  class="profile-edit__input"
                  type="password"
                  title="Текущий пароль"
                  placeholder="Введите текущий пароль"
                  :popup="
                    validPopup(
                      !$v.user.currentPassword.required,
                      'Не забудьте заполнить это поле :)'
                    ) || validPopup(!$v.user.currentPassword.isTrue, 'Неверный пароль')
                  "
                ></UiInput>
              </div>
              <div class="profile-edit__field">
                <UiInput
                  v-model.trim="user.currentPasswordRepeat"
                  class="profile-edit__input"
                  type="password"
                  title="Повтор пароля"
                  placeholder="Введите текущий пароль еще раз"
                  :popup="
                    validPopup(
                      !$v.user.currentPasswordRepeat.required,
                      'Не забудьте заполнить это поле :)'
                    ) || validPopup(!$v.user.currentPasswordRepeat.equal, 'Пароли не совпадают')
                  "
                ></UiInput>
              </div>
            </div>
            <div class="profile-edit__col">
              <div class="profile-edit__field">
                <UiInput
                  v-model.trim="user.newPassword"
                  class="profile-edit__input"
                  type="password"
                  title="Новый пароль"
                  placeholder="Введите новый пароль"
                  :popup="
                    validPopup(
                      !$v.user.newPassword.required,
                      'Не забудьте заполнить это поле :)'
                    ) ||
                    validPopup(
                      !$v.user.newPassword.minLength,
                      `Минимальная длина пароля ${$v.user.newPassword.$params.minLength.min} символов`
                    )
                  "
                ></UiInput>
              </div>
              <div class="profile-edit__field">
                <UiInput
                  v-model.trim="user.newPasswordRepeat"
                  class="profile-edit__input"
                  type="password"
                  title="Повтор нового пароля"
                  placeholder="Введите новый пароль еще раз"
                  :popup="
                    validPopup(
                      !$v.user.newPasswordRepeat.required,
                      'Не забудьте заполнить это поле :)'
                    ) ||
                    validPopup(
                      !$v.user.newPasswordRepeat.minLength,
                      `Минимальная длина пароля ${$v.user.newPasswordRepeat.$params.minLength.min} символов`
                    ) ||
                    validPopup(!$v.user.newPasswordRepeat.equal, 'Пароли не совпадают')
                  "
                ></UiInput>
              </div>
            </div>
          </div>
        </div>
        <div class="profile-edit__row -password-">
          <div class="profile-edit__col">
            <uiButton
              class="profile-edit__button"
              to="/resetpassword"
              color="light"
              @click="forgotPassword"
            >
              Не помню пароль
            </uiButton>
          </div>
          <div class="profile-edit__col">
            <uiButton class="profile-edit__button" @click="updatePassword">
              Изменить пароль
            </uiButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      user: {
        currentPassword: '',
        currentPasswordRepeat: '',
        newPassword: '',
        newPasswordRepeat: ''
      },
      error: ''
    };
  },
  computed: {
    passwordServerError() {
      if (this.error) {
        return this.error.find(err => err.message === 'Неверный пароль');
      }
      return undefined;
    }
  },
  watch: {
    'user.currentPassword'() {
      if (this.passwordServerError) {
        this.error = '';
      }
    }
  },
  methods: {
    async updatePassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      const result = await this.$store.dispatch('settingStore/updatePassword', {
        currentPassword: this.user.currentPassword,
        newPassword1: this.user.newPassword,
        newPassword2: this.user.newPasswordRepeat
      });
      if (result == 'success') {
        this.$router.push('/user/settings');
      } else {
        this.error = result.errors;
      }
    },
    validPopup(isErr, text) {
      if (!this.$v.$dirty) {
        return;
      }
      if (isErr) {
        return { msg: text, error: true };
      }
    }
  },
  validations: {
    user: {
      currentPassword: {
        required,
        isTrue() {
          return !this.passwordServerError;
        }
      },
      currentPasswordRepeat: {
        equal(currentPasswordRepeat) {
          return this.user.currentPassword === currentPasswordRepeat;
        },
        required
      },
      newPassword: { required, minLength: minLength(6) },
      newPasswordRepeat: {
        required,
        minLength: minLength(6),
        equal(newPasswordRepeat) {
          return this.user.newPassword === newPasswordRepeat;
        }
      }
    }
  }
};
</script>
